import { render } from "./Power.vue?vue&type=template&id=572753dc&scoped=true"
import script from "./Power.vue?vue&type=script&lang=js"
export * from "./Power.vue?vue&type=script&lang=js"

import "./Power.vue?vue&type=style&index=0&id=572753dc&scoped=true&lang=css"

import exportComponent from "C:\\bipom\\VSVN\\dude\\Web\\SmartLamp\\2.03\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572753dc"]])

export default __exports__